/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Code_InvalidInputs */

const id_staff_code_invalid = /** @type {(inputs: Staff_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode salah atau sudah kedaluwarsa. Masukkan kode yang sedang tampil.`)
};

const en_staff_code_invalid = /** @type {(inputs: Staff_Code_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong or expired code. Enter the code showing now.`)
};

/**
* | output |
* | --- |
* | "Wrong or expired code. Enter the code showing now." |
*
* @param {Staff_Code_InvalidInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_code_invalid = /** @type {((inputs?: Staff_Code_InvalidInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Code_InvalidInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_code_invalid(inputs)
	return id_staff_code_invalid(inputs)
});